import PropTypes from 'prop-types';
import { values } from 'ramda';
import { Image } from '../schema/prismic/fields/image';
import { LinkDocument, LinkMedia } from '../schema/prismic/fields/link';
import { Filters, Meta, Page } from './document';

export const MEDIA_TYPE = {
  AUDIO: 'audio',
  COMMUNICATION: 'communication',
  INFOGRAPHIC: 'infographic',
  PHOTO: 'photo',
  PUBLICATION: 'publication',
  RELEASE: 'release',
  VIDEO: 'video',
};

export type MediaPress = Page & {
  description: string;
  publication: string;
  mediaType: string;
  thematic: string;
  region: string;
  image: Image;
  link: LinkMedia;
  downloadUrl: string;
  related_article: LinkDocument;
  onNewsroom: boolean;
  filters: Filters;
  date?: number;
  onFinance?: boolean;
  relatedDate?: number;
  transcription?: string;
  classCategory?: string;
  onHome: boolean;
  meta: Meta;
};

export const MediaType = PropTypes.oneOf(values(MEDIA_TYPE));
